export default from './AnnualIncomeQuestion';



// WEBPACK FOOTER //
// ./src/sharedComponents/Quiz/components/AnnualIncomeQuestion/index.js